import { type ComponentType, type CSSProperties, type FC } from 'react';
import cx from 'classnames';

import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { type VoidFunction } from 'src/lib/types';

import styles from './ActionButton.module.scss';

interface ActionButtonProps {
  className?: string;
  title: string;
  Icon: ComponentType<{ className?: string }>;
  tooltip: string;
  onClick: VoidFunction;
  disabled?: boolean;
  customColors?: {
    backgroundDefault: string;
    backgroundHover: string;
    icon: string;
  };
}

export const ActionButton: FC<ActionButtonProps> = ({
  className,
  title,
  Icon,
  tooltip,
  onClick,
  disabled,
  customColors,
  ...restProps
}) => {
  return (
    <CustomTooltip
      title={tooltip}
      placement="top"
    >
      <CustomButtonBase
        className={cx(styles.root, className)}
        style={
          {
            '--custom-background-default': customColors?.backgroundDefault,
            '--custom-background-hover': customColors?.backgroundHover,
            '--custom-color-icon': customColors?.icon,
          } as CSSProperties
        }
        onClick={onClick}
        disabled={disabled}
        {...restProps}
      >
        <div className={styles.iconWrapper}>
          <Icon className={styles.icon} />
        </div>

        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.regular14}
          component="span"
        >
          {title}
        </CustomTypography>
      </CustomButtonBase>
    </CustomTooltip>
  );
};
